import axios from 'axios';
import axiosUrl from './axios.service';
import authHeader from '../helpers/auth-header';
import store from '../store/index';
import AuthService from '../services/auth.service';
import router from '../router';
const API_URL = axiosUrl.getAxiosUrl();

class StatisticsService {
  async subjectCounts(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes
  ) {
    return axios
      .post(API_URL + `/Statistics/subjectCounts`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
      },
      {
        headers: authHeader()
      })
      .then((response) => {
        var chartData = response.data;
        store.commit('statistics/updateFullPieChartData', chartData);
      })
      .catch((error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async customerCounts(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes
  ) {
    return axios
      .post(API_URL + `/Statistics/customerCounts`, 
      {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
      },
      {
        headers: authHeader()
      })
      .then((response) => {
        var chartData = response.data;
        store.commit('statistics/updateFullHorizontalBarChartData', chartData);
        store.commit('statistics/setIsStatisticLoading', false);
      })
      .catch((error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async customerSubsidy(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes
  ) {
    return axios
      .post(API_URL + `/Statistics/customerSubsidy`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
      },
      {
        headers: authHeader()
      })
      .then((response) => {
        var chartData = response.data;
        store.commit('statistics/updateFullBarChartData', chartData);
      })
      .catch((error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async customerSchemes(customerName, year) {
    return axios
      .get(API_URL + `/Statistics/customerSchemes`, {
        headers: authHeader(),
        params: {
          customerName: customerName,
          year: year,
        },
      })
      .then((response) => {
        var data = response.data;
        store.commit('statistics/setTableRows', data);
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async filterRecords(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes
  ) {
    return axios
      .post(API_URL + `/Statistics/filterRecords`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id}) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
      },
      {
        headers: authHeader()
      })
      .then((response) => {
        var data = response.data;
        store.commit('statistics/setStatisticsTableRows', data);
      })
      .catch((error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async exportRecords(
    dateFrom,
    dateTo,
    organisations,
    subjects,
    customers,
    years,
    scopes
  ) {
    return axios
      .post(API_URL + `/Statistics/exportStatistics`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        organisations: organisations != null ? organisations.map(d => { return d.id }) : [],
        applicationSubjects: subjects != null ? subjects.map(d => { return d.id }) : [],
        customers: customers != null ? customers.map(d => { return d.id }) : [],
        scopes: scopes != null ? scopes.map(d => { return d.id }) : [],
        years: years != null ? years.map(d => { return d.id }) : [],
      },
      {
        headers: authHeader(),
        responseType: 'blob'
      })
      .then((res) => {
        const dateTimeTicks = new Date().getTime();
        const fn = 'Statistics' + dateTimeTicks + '.xlsx';
        let blob = new Blob([res.data], { type: res.headers['content-type'] });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fn;
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
}

export default new StatisticsService();
